import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const ChevronRight = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.57103 3.14574C5.79737 2.93859 6.14878 2.95413 6.35594 3.18047L10.4171 7.61767C10.6786 7.90333 10.6729 8.34306 10.404 8.62182L6.34603 12.8301C6.13305 13.0509 5.78135 13.0573 5.56049 12.8444C5.33962 12.6314 5.33323 12.2797 5.54621 12.0588L9.35786 8.10603L5.53631 3.93065C5.32915 3.70431 5.3447 3.3529 5.57103 3.14574Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ChevronRight;
